import { Col, Tag, Typography } from 'antd';
import { ProjectsConstructorCard } from '@/components';
import { EpicGroupForm } from './EpicGroupForm';
import { AddEpicGroupDto, EpicGroupDto, ProjectDto } from '@/core';
import { useDeleteEpicGroupMutation, useUpdateEpicGroupMutation } from '@/redux';
import { useTagColor } from './hooks';
import classes from './EpicGroupCard.module.scss';

type CardProps = EpicGroupDto & {
  onClickMenuEdit: () => void;
  isEdit: boolean;
  stopEditCard: (id: string) => void;
  projectData: ProjectDto;
};

const findEpicNameById = (epicId: string, projectData: ProjectDto) => {
  return projectData.epics.find((x) => x.id === epicId)?.name;
};

export const EpicGroupCard = ({
  name,
  type,
  epics,
  isEdit,
  id,
  onClickMenuEdit,
  stopEditCard,
  projectData,
}: CardProps) => {
  const [updateEpicGroup] = useUpdateEpicGroupMutation();
  const [deleteEpicGroup] = useDeleteEpicGroupMutation();
  const tagColor = useTagColor(type);

  const submitUpdate = (epicGroupData: AddEpicGroupDto) => {
    updateEpicGroup({ epicGroupData, id })
      .unwrap()
      .then(() => stopEditCard(id));
  };
  const onClickMenuDelete = () => deleteEpicGroup({ id });

  return (
    <ProjectsConstructorCard
      isEdit={isEdit}
      onClickMenuDelete={onClickMenuDelete}
      onClickMenuEdit={onClickMenuEdit}
      invalidCard={!epics.length}
      editForm={
        <EpicGroupForm
          handleCancel={() => stopEditCard(id)}
          handleSubmit={submitUpdate}
          initialValue={{ type, name, epics }}
          formUid={name}
          isCancelButton
          projectData={projectData}
          epicType={type}
          editedGroupId={id}
        />
      }
    >
      <Col xs={6} md={3}>
        <div className={classes.tagsWrapper}>
          <Tag color={tagColor}>
            <Typography.Text ellipsis>{type}</Typography.Text>
          </Tag>
        </div>
      </Col>
      <Col span={8} className="ps-2">
        <Typography.Paragraph className="pe-3">{name}</Typography.Paragraph>
      </Col>
      <Col xs={10} md={13}>
        <div className={classes.tagsWrapper}>
          {epics.map((epic: string) => (
            <Tag key={epic}>
              <Typography.Text ellipsis>{findEpicNameById(epic, projectData)}</Typography.Text>
            </Tag>
          ))}
        </div>
      </Col>
    </ProjectsConstructorCard>
  );
};
